<template>
  <div class="question-block text-center py-5">
    <div class="question-block__icon">
      <fa-icon
        icon="question-circle"
        size="5x"
      />
    </div>
    <div class="text-thin h5">
      ¿Cómo crees que le fue a <strong>los estudiantes de
        {{ careerName }} en las Pruebas Nacionales</strong>?
    </div>
    <h3 v-if="!showResponse">
      Promedio Pruebas Nacionales
    </h3>
    <div
      v-if="!showResponse"
      class="d-flex justify-content-center align-items-center"
    >
      <div class="radio-btn-group">
        <div class="radio">
          <input
            id="worst"
            v-model="mean_response"
            type="radio"
            name="radio"
            value="6"
            checked="checked"
          >
          <label for="worst"> <fa-icon :icon="['far', 'frown']" /> Muy mal</label>
        </div>
        <div class="radio">
          <input
            id="bad"
            v-model="mean_response"
            type="radio"
            name="radio"
            value="12"
          >
          <label for="bad"> <fa-icon :icon="['far', 'frown']" /> Mal</label>
        </div>
        <div class="radio">
          <input
            id="average"
            v-model="mean_response"
            type="radio"
            name="radio"
            value="18"
          >
          <label for="average"> <fa-icon :icon="['far', 'smile']" /> Normal</label>
        </div>
        <div class="radio">
          <input
            id="good"
            v-model="mean_response"
            type="radio"
            name="radio"
            value="24"
          >
          <label for="good"> <fa-icon :icon="['far', 'star']" /> Bien</label>
        </div>
        <div class="radio">
          <input
            id="excellent"
            v-model="mean_response"
            type="radio"
            name="radio"
            value="30"
          >
          <label for="excellent">
            <fa-icon :icon="['far', 'star']" /><fa-icon :icon="['far', 'star']" /> Bien
          </label>
        </div>
      </div>
    </div>
    <div
      v-if="showResponse"
      class="d-flex justify-content-center align-items-center"
    >
      <p> {{ appResponse }}</p>
    </div>
    <base-button
      v-if="!showResponse"
      @click="onResponse"
    >
      Responder
    </base-button>
    <base-button
      v-if="showResponse"
      @click="onSubmit"
    >
      Conocer más
    </base-button>
  </div>
</template>

<script>
export default {
    name: 'SalaryQuestion',
    props: {
        careerName: {
            type: String,
            required: true,
        },
        careerAverage: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            mean_response: 0,
            showResponse: false,
            appResponse: 'Estamos recopilando datos para entregarte información detallada sobre esta carrera',
            career_mean: 0,
        };
    },
    methods: {
        onSubmit() {
            const jsonResponse = {
                guess: parseFloat(this.mean_response),
                real: this.career_mean,
            };
            this.$emit('answered', 'grades', jsonResponse);
        },
        onResponse() {
            let average = 0;
            this.showResponse = true;
            let spanishMean = 0;
            let mathMean = 0;
            for (let i = 0; i < this.careerAverage.length; i += 1) {
                average += this.careerAverage[i].avg;

                if (this.careerAverage[i].name === 'Lengua Española') {
                    spanishMean = this.careerAverage[i].avg;
                } else if (this.careerAverage[i].name === 'Matemáticas') {
                    mathMean = this.careerAverage[i].avg;
                }
            }
            average /= this.careerAverage.length;
            this.career_mean = average;
            const lowerBound = average - 2;
            const upperBound = average + 2;
            if (this.mean_response < lowerBound) {
                this.appResponse = 'El puntaje promedio de las 4 asignaturas '.concat(
                    'de Pruebas Nacionales que obtuvieron los egresados de esta carrera fue ',
                    average.toFixed(2),
                    '. ¡Mejor de lo que pensabas!',
                );
            } else if (this.mean_response > upperBound) {
                this.appResponse = 'Según información de egresados el promedio en lenguaje es '.concat(
                    spanishMean.toFixed(2), ' y en matemáticas ', mathMean.toFixed(2), '. ',
                );
            } else {
                this.appResponse = 'Muy bien! tu respuesta ha sido muy cercana a la cifra oficial. '.concat(
                    'El puntaje promedio de las 4 asignaturas de Pruebas Nacionales que obtuvieron ',
                    'los egresados de esta carrera fue ',
                    average.toFixed(2),
                );
            }
        },
    },
};
</script>
<style lang="scss">
@import "../../scss/style";
.question-block{
    &__icon{
        color: $primary;
    }
    & > div{
        margin-bottom: 1rem;
    }
    &__response{
        max-width: 80px;
        text-align: right;

        &[type=number]::-webkit-inner-spin-button,
        &[type=number]::-webkit-outer-spin-button
        {
            display: none;
        }
    }
}

.radio-btn-group {
  display: flex;

  .radio {
    margin: 0 .25rem;

    label {
      background: #fff;
      border: 1px solid #ddd;
      padding: .5rem 1.25rem;
      border-radius: 5px;
      cursor: pointer;
      color: #444;
      transition: box-shadow 400ms ease;

      &:hover {
        box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
      }
    }

    input[type="radio"] {
      display: none;
    }

    input[type="radio"]:checked+label {
      background: #2196F3;
      color: #fff;
      border-color: #2196F3;
    }
  }
}


</style>
